import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {Condicion} from "../../clases/Condicion";
import {EncuestaDTO, ItemPreguntaDTO, PreguntaDTO} from "@DTOS";
import {CommandAsync, ICommand} from "@nahuelmorata/ngx-command";
import {Nilable} from "@shared/utils";
import {ModalService} from "@shared/services";
import {ItemPreguntaModelDTO, PreguntaModelDTO} from "@Models";
import {PreguntasTipoEnum} from "@shared/enums";


@Component({
    selector: "app-condicion-si-contesto",
    templateUrl: "./condicion-si-contesto.component.html",
    styleUrls: ["./condicion-si-contesto.component.scss"]
})
export class CondicionSiContestoComponent implements OnChanges {
    @Input() public encuesta: EncuestaDTO;
    @Input() public condicion: Condicion;
    @Input() public pregunta: PreguntaModelDTO;
    @Input() public item: ItemPreguntaModelDTO;

    public preguntas: PreguntaDTO[];
    public respuestas: ItemPreguntaDTO[];

    public preguntaSeleccionada: Nilable<PreguntaDTO>;
    public subpreguntaSeleccionada: Nilable<PreguntaDTO>;
    public itemSeleccionado: Nilable<ItemPreguntaDTO>;

    public PreguntasTipoEnum = PreguntasTipoEnum;


    public borrarOperandoCmd: ICommand = new CommandAsync(() => this.borrar());

    constructor(private modalService: ModalService) {
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.encuesta != null && (changes.pregunta != null || changes.item != null)) {
            let idPreguntaActual: number;
            if (this.pregunta != null) {
                idPreguntaActual = changes.pregunta.currentValue.Padre == null ? changes.pregunta.currentValue.Id :
                    changes.encuesta.currentValue.preguntas.find(pregunta =>
                        pregunta.id === changes.pregunta.currentValue.Padre).id;
            } else {
                if (changes.item != null) {
                    idPreguntaActual = changes.encuesta.currentValue.preguntas.find(pregunta =>
                        pregunta.items.some(item => item.id === changes.item.currentValue.Id)).id;
                } else {
                    idPreguntaActual = changes.encuesta.currentValue.preguntas.find(pregunta =>
                        pregunta.preguntas != null ? pregunta.preguntas.some(subpregunta =>
                            subpregunta.items.some(item => item.id === changes.item.currentValue.Id)) :
                            pregunta.items.some(item => item.id === changes.item.currentValue.Id)
                    ).id;
                }
            }
            this.preguntas = changes.encuesta.currentValue.preguntas?.filter(pregunta =>
                pregunta.items.length > 0 && pregunta.id < idPreguntaActual) ?? [];
        }
        if (changes.condicion != null) {
            if (this.condicion.data) {
                this.parsearCondicion(this.condicion.data);
            }
        }
    }

    public preguntaCambio() {
        this.subpreguntaSeleccionada = null;
        this.itemSeleccionado = null;

        if (this.preguntaSeleccionada != null) {
            if (![PreguntasTipoEnum.MATRIX_MULTIPLE, PreguntasTipoEnum.MATRIX_SINGLE]
                .includes(this.preguntaSeleccionada.tipo)) {
                this.respuestas = this.preguntaSeleccionada.items;
            }
            this.condicion.data = `q${this.preguntaSeleccionada.id}`;
        }
    }

    public subpreguntaCambio() {
        this.itemSeleccionado = null;

        if (this.subpreguntaSeleccionada != null) {
            this.respuestas = this.subpreguntaSeleccionada.items;
            this.condicion.data = `q${this.subpreguntaSeleccionada.id}`;
        }
    }

    public itemCambio() {
        if (this.itemSeleccionado) {
            this.condicion.data = `i${this.itemSeleccionado.id}`;
        }
    }

    private parsearCondicion(condicion: string) {
        if (condicion.startsWith("q") || condicion.startsWith("i")) {
            if (condicion.startsWith("q")) {
                this.preguntaSeleccionada = this.preguntas.filter(pregunta =>
                    pregunta.id === parseInt(condicion.slice(1), 10))[0];
            }
            if (condicion.startsWith("i")) {
                this.preguntas.forEach(pregunta => {
                    if (pregunta.preguntas == null) {
                        if (pregunta.items.some(item => item.id === parseInt(condicion.slice(1), 10))) {
                            this.preguntaSeleccionada = pregunta;
                            this.respuestas = this.preguntaSeleccionada.items;
                            this.itemSeleccionado = this.preguntaSeleccionada.items
                                .find(item => item.id === parseInt(condicion.slice(1), 10))!;
                        }
                    } else {
                        if (pregunta.preguntas.some(subPregunta => subPregunta.items.some(itemSubpregunta =>
                            itemSubpregunta.id === parseInt(condicion.slice(1), 10)))) {
                            this.preguntaSeleccionada = pregunta;
                            this.respuestas = this.preguntaSeleccionada.items;
                            this.subpreguntaSeleccionada = pregunta.preguntas.find(subPregunta =>
                                subPregunta.items.some(itemSubpregunta =>
                                    itemSubpregunta.id === parseInt(condicion.slice(1), 10)))!;
                            this.itemSeleccionado = this.subpreguntaSeleccionada.items.find(itemSubpregunta =>
                                itemSubpregunta.id === parseInt(condicion.slice(1), 10))!;
                        }
                    }
                });
            }
        } else {
            const splitCondicion = condicion.split(".");

            const indexPreguntaRelativo = splitCondicion[0];

            this.preguntaSeleccionada = this.preguntas.filter(pregunta =>
                pregunta.idRelativo === indexPreguntaRelativo)[0];
            this.respuestas = this.preguntaSeleccionada.items;

            if (splitCondicion.length > 1) {
                this.itemSeleccionado = this.preguntaSeleccionada.items.filter(item =>
                    item.idRelativo === condicion)[0];
            }

            this.cambiarPorAbsoluto();
        }
    }

    private async borrar() {
        const seguroBorrar = await this.modalService.openModalDecision(
            "Esta seguro que quiere eliminar el operando?", {centered: true}
        );

        if (!seguroBorrar) {
            return;
        }

        this.condicion.borrar();
    }

    private cambiarPorAbsoluto() {
        if (this.preguntaSeleccionada) {
            this.condicion.data = `q${this.preguntaSeleccionada.id}`;
        }

        if (this.itemSeleccionado) {
            this.condicion.data = `i${this.itemSeleccionado.id}`;
        }
    }
}
